<!--常见的tab
-->
<template>
	<div class="tabBody" ref="box">
	
		<div ref="top" class="tab">
			<div :key="i" :style="name==item.name?$store.resourcesStore.getters.getBackgroudImageStyle('wedoButton/bar.png'):''" class="tabitem" v-for="(item,i) in tabList" @click="chooseTab(item)">
				{{item.name}}
			</div>
		</div>
		<div class="body">
			<slot name="tabbody"></slot>
			<slot ></slot>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: [
			"tabList", "titleList"
		],
		data() {
			return {
				titleName: '',
				name: ''
			}
		},
		created() {},
		mounted() {
			this.name = this.tabList[0].name;
			this.titleName = this.tabList[0].titleName;
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			chooseTab(item) {
				this.name = item.name;
				this.titleName = item.titleName;
				this.$emit("chooseTab", item)
			}
		}
	}
</script>

<style scoped>
	.tabBody {
		width: 100%;
		height: 100%;
		background: #f0f0f0;
	}

	.select {
		background-color: #10A4E2;
	}

	.table-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #515A6E;
		height: 38px;
		width: 100%;
		/* width: calc(100% - 1rem - 1px); */
	}

	.tree-column {
		/* padding-right: 10px;
		padding-left: 5px; */
		height: 38px;
		line-height: 38px;
		width: 2rem;
		border-left: 1px solid #000000;
	}

	.item-other {
		line-height: 38px;
		flex-grow: 1;
		border-left: 1px solid #000000;
	}

	.tab {
		display: flex;
		align-items: center;
		color: #515A6E;
		height: .5rem;
		/* width: calc(100% - 1rem - 1px); */
		width: 100%;
		background: white;
	}

	.tab .tabitem {
		color: #515A6E;
		line-height: 0.5rem;
		height: 0.5rem;
		text-align: center;
		width: 2rem;
	}

	#resize {
		line-height: 100%;
		width: 10px;
		height: 100%;
		cursor: w-resize;
		float: left;
		background-color: #cacaca;
	}

	#resize img {
		height: 100%;
		width: 10px;
	}
	.item-other-group{
		margin-right: 30px;
		display: flex;
		align-content: center;
		width: 10rem;
	}
	.body {
		height:calc(100% -  .5rem) ;
		width: 100%;
		/* width: calc(100% - 1rem - 1px); */
	}
</style>
